import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Shell from "../components/Shell";
import { useAuth } from "../context/AuthContext";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        const res = await login(email, password);
        setLoading(false);
        if (res.ok) {
            if (res.user.role === "admin") navigate("/admin");
            else if (res.user.status === "approved") navigate("/dashboard");
            else navigate("/pending");
        } else {
            setError(res.error);
        }
    };

    return (
        <Shell variant="public">
            <div className="min-h-[calc(100vh-4rem)] grid lg:grid-cols-2">
                <div className="hidden lg:block relative">
                    <img
                        src="https://images.pexels.com/photos/16571735/pexels-photo-16571735.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940"
                        alt=""
                        className="absolute inset-0 w-full h-full object-cover"
                    />
                    <div className="absolute bottom-6 left-6 right-6 sm:right-auto bg-black px-5 py-4 max-w-sm">
                        <p className="text-[10px] uppercase tracking-[0.3em] text-white/70 mb-1.5">Private B2B Distribution</p>
                        <h2 className="font-heading text-base xl:text-lg font-light leading-snug text-white">A clinic-only ordering portal for New Zealand aesthetic medicine.</h2>
                    </div>
                </div>
                <div className="flex items-center justify-center px-6 py-16">
                    <div className="w-full max-w-sm animate-fade-in">
                        <p className="eyebrow mb-3">Welcome back</p>
                        <h1 className="font-heading text-3xl sm:text-4xl font-light tracking-tight text-black mb-2">Sign in to your clinic account</h1>
                        <p className="text-sm text-zinc-500 mb-10">Only approved clinics may access the catalogue, pricing and downloads.</p>

                        <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
                            <div>
                                <label className="input-label">Email</label>
                                <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input-base" autoComplete="email" />
                            </div>
                            <div>
                                <div className="flex items-baseline justify-between">
                                    <label className="input-label">Password</label>
                                    <Link to="/forgot-password" data-testid="link-forgot" className="text-xs text-zinc-500 hover:text-black">Forgot?</Link>
                                </div>
                                <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input-base" autoComplete="current-password" />
                            </div>
                            {error && <div data-testid="login-error" className="text-sm text-red-700 bg-red-50 border border-red-200 px-4 py-2.5 rounded-sm">{error}</div>}
                            <button data-testid="login-submit" type="submit" disabled={loading} className="btn-primary w-full">{loading ? "Signing in…" : "Sign in"}</button>
                        </form>

                        <div className="mt-10 pt-6 border-t border-zinc-200 flex items-center justify-between text-sm">
                            <span className="text-zinc-500">New clinic?</span>
                            <Link to="/register" data-testid="link-register" className="text-black underline-offset-4 hover:underline">Apply for access →</Link>
                        </div>
                    </div>
                </div>
            </div>
        </Shell>
    );
}
